import {ProcessedTripItinerary, TourOperator} from "../contentfulModel.ts";
import React from "react";
import {getTickIcon, renderRichText, RichTextNode} from "../utils.tsx";

interface ItineraryHotelsPDFProps {
    tourPackage: ProcessedTripItinerary;
    tourOperator: TourOperator
}

export const ItineraryHotelsPDF : React.FC<ItineraryHotelsPDFProps> = ({
    tourPackage,
    tourOperator
}) => {

    const renderHotelGroups = (hotels: any[]) => {

        //iterate over hierarchy of hotels
        return hotels.map(
            (hotelGroup: any, index: number) => {
                return (
                    <div key={index} className="flex flex-col gap-2 ">
                        <div className="text-[12pt] font-bold text-start mb-2 pb-1" style={{
                            color: tourOperator.secondaryColor || "#000000",
                            borderBottom: `1pt solid ${tourOperator.secondaryColor || "#000000"}`,
                        }}>{hotelGroup.category}</div>
                        <div className="grid grid-cols-2 gap-x-10 gap-y-5">
                            {hotelGroup.cities.map((city) => (
                                <div key={city.name} className="flex flex-col">
                                    <div className="uppercase text-[12pt] font-bold text-start text-[#1A1A1A]">{city.name}</div>
                                    <div className="">
                                        {city.hotels.map((hotel: string, hotelIndex: number) => (
                                            <div key={hotelIndex} className="uppercase text-[8pt] text-start  font-light text-[#1A1A1A]">{hotel}</div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            }
        )
        //iterate over keys values


    }

    return (
        <div className="flex flex-col" style={{
            aspectRatio:  1.4136,
            height:"29.71cm",
            width: "42cm"
        }}>
        <div className="w-full min-h-[40%] max-h-[40%]" style={{
            backgroundImage: `url(${tourPackage?.mainImage.file?.includes(" ") ? encodeURI(tourPackage?.mainImage.file) : tourPackage?.mainImage.file})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 0
        }}>
            {/* Content without filter */}
            <div className="relative z-10 text-white p-10 py-6 h-full flex flex-col w-full justify-between">
                <div className="flex flex-row justify-between">
                    <div className="text-lg font-light  text-start">{tourPackage.name}</div>
                    <div className="flex justify-end">
                        <div className="uppercase text-lg font-light text-start"
                             style={{color: 'white'}}>{tourOperator.name}</div>
                    </div>
                </div>
                <div className="flex items-center justify-end gap-4">
                    <div className="rounded-full px-6 py-4  font-medium text-2xl uppercase" style={{
                        color: tourOperator.primaryColor || "#000000",
                        fontSize: "22pt",
                        lineHeight: "22pt",
                        background: "rgba(255, 255, 255, 0.9)"

                    }}>{tourPackage.subtitle || tourPackage.itinerary.length - 1 + " NOCHES"}
                    </div>
                    {tourPackage.price && (
                        <div className="rounded-full px-6 py-2  font-medium text-2xl" style={{
                            color: tourOperator.primaryColor || "#000000",
                            fontSize: "20pt",
                            lineHeight: "18pt",
                            background: "rgba(255, 255, 255, 0.9)"
                        }}>
                            <div className="text-[10pt] uppercase font-light">Desde</div>
                            <div>{tourPackage.price}</div>
                        </div>)}
                </div>
            </div>
        </div>
            <div className="max-h-[60%] flex flex-row px-12 py-10 gap-40">
                <div className="w-[100%] h-full">
                    <div className="font-bold text-2xl text-start" style={{
                        color: tourOperator.primaryColor || "#000000",
                    }}>Hoteles
                    </div>
                    <div className="flex flex-col h-full">

                        <div className=" h-full flex flex-col gap-[45px] gap-y-[20px] mt-4 w-full flex-wrap justify-start items-start content-start">
                            {renderHotelGroups(tourPackage.hotels)}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
